import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const articleMembershipApi = generateNomenApi(`/article/article-membership`);

export const articleMembershipOptions = generateNomenOptions('article-membership', articleMembershipApi);
